import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { SectionProps } from "../../utils/SectionProps";
import Input from "../elements/Input";

const propTypes = {
  ...SectionProps.types,
  split: PropTypes.bool,
};

function sendInput() {
  let email;
  let text;
  email = document.getElementById("email").value;
  text = document.getElementById("text").value;


  try {
    fetch("https://api.notif.tumbo.dev/", 
    {headers: { "Content-Type" : "application/json"}, 

    method: "POST", 
    body: JSON.stringify([{"util": "discord_utils",
       "function": "send_to_webhook",
       "parameters": ["https://discord.com/api/webhooks/1072971599290056734/fGWjGZDwXJpV3uuvvGnFv9CdYULXJ8bxPFFEvkJyXCkjCYq5ZQe_iVAKbVAVD1HmPChN", "Form Contact", JSON.stringify({"email": email, "text": text})]}]),
      })



 
  } catch (error) {
    console.log(error);
  }
}

const defaultProps = {
  ...SectionProps.defaults,
  split: false,
};

const Cta = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  split,
  ...props
}) => {
  const outerClasses = classNames(
    "cta section center-content-mobile reveal-from-bottom",
    topOuterDivider && "has-top-divider",
    bottomOuterDivider && "has-bottom-divider",
    hasBgColor && "has-bg-color",
    invertColor && "invert-color",
    className
  );

  const innerClasses = classNames(
    "cta-inner section-inner",
    topDivider && "has-top-divider",
    bottomDivider && "has-bottom-divider",
    split && "cta-split"
  );

  return (
    <section {...props} className={outerClasses}>
      <div className="container-form">
        <div className={innerClasses}>
          <div className="cta-slogan">
            <h3 className="m-0">
              Do you have any problem that we can help you with?
            </h3>
          </div>
          <form>
            <div className="cta-action">
              <Input
                id="email"
                type="email"
                placeholder="Your best email"
              ></Input>
              <Input
                height="200px"
                id="text"
                type="text"
                label="idea"
                labelHidden
                placeholder="Share your situation"
              ></Input>
            </div>
            <div style={{ margin:"auto"}}>
              <button
                className="button button-primary button-wide-mobile button-sm"
                onClick={sendInput}
              >
                Send
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

Cta.propTypes = propTypes;
Cta.defaultProps = defaultProps;

export default Cta;
